import React from 'react';

export interface ToggleState<T = undefined> {
  open: () => void;
  toggle: () => void;
  close: () => void;
  setData: React.Dispatch<React.SetStateAction<T | undefined>>;
  opened: boolean;
  data: T | undefined;
}

const useToggle = <T = undefined>(openedInitial?: boolean, dataInitial?: T): ToggleState<T> => {
  const [opened, setOpened] = React.useState(openedInitial || false);
  const [data, setData] = React.useState<T | undefined>(dataInitial);
  const open = () =>
    setOpened(() => {
      return true;
    });
  const close = () =>
    setOpened(() => {
      return false;
    });
  const toggle = () =>
    setOpened((e) => {
      return !e;
    });

  return { opened, open, close, toggle, data, setData };
};

export default useToggle;
